import { useInfiniteQuery } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { IBlackBoxInventoryQuery } from '../../../types';

/**
 * This is to track the blackbox inventory list from the backend.
 */
export const BLACKBOX_INVENTORY_INFO_QUERY_KEY =
  'blackbox-inventories-info-query-key';

/**
 * This hook fetches the Blackbox Inventory information from the backend.
 */
export const useBlackboxInventoriesInfoQuery = ({
  enabled = true,
  payload,
}: IBlackBoxInventoryQuery) => {
  const { limit, search, inventoryTransactionId, page } = payload;
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  } = useInfiniteQuery({
    enabled,
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      BLACKBOX_INVENTORY_INFO_QUERY_KEY,
      inventoryTransactionId,
      limit,
      page,
      search,
    ],
    initialPageParam: 1,
    networkMode: 'always',
    retry: false,
    queryFn: ({ pageParam = 1 }) =>
      INV_MGMT_SERVICE_API.getBlackboxInventories({
        ...payload,
        page: pageParam,
      }),

    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      const currentCount = allPages.length * limit;

      return currentCount < lastPage.total ? nextPage : undefined;
    },
  });

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  };
};
